module.exports = __webpack_public_path__ + "img/ligdata-logo-light.b4ae9a9c.png";